import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BranchSchedule } from '../../interfaces/branch';

@Component({
  selector: 'app-branch-schedule',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './branch-schedule.component.html',
  styleUrls: ['./branch-schedule.component.scss']
})
export class BranchScheduleComponent {
  @Input() schedules: BranchSchedule[] | undefined = [];
  @Input() branchAddress: string = '';
  @Input() showDrinkHoppingTip: boolean = false;

  // Keys used with translate pipe: 'schedule.days.0' … 'schedule.days.6'
  readonly DAY_KEYS = [0, 1, 2, 3, 4, 5, 6];

  get sortedSchedules(): BranchSchedule[] {
    if (!this.schedules || this.schedules.length === 0) return [];
    return [...this.schedules].sort((a, b) => {
      const order = [1, 2, 3, 4, 5, 6, 0];
      return order.indexOf(a.dayOfWeek) - order.indexOf(b.dayOfWeek);
    });
  }

  get hasSchedules(): boolean {
    return !!(this.schedules && this.schedules.length > 0);
  }

  formatTime(time: string | undefined): string {
    if (!time) return '';
    const [hours, minutes] = time.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  getCloseTime30MinBefore(closeTime: string | undefined): string {
    if (!closeTime) return '';
    const [hours, minutes] = closeTime.split(':').map(Number);
    const totalMinutes = hours * 60 + minutes - 30;
    const newHours = Math.floor(totalMinutes / 60);
    const newMinutes = totalMinutes % 60;
    if (newHours < 0) return '';
    const period = newHours >= 12 ? 'PM' : 'AM';
    const displayHours = newHours % 12 || 12;
    return `${displayHours}:${newMinutes.toString().padStart(2, '0')} ${period}`;
  }
}
